import { render, staticRenderFns } from "./settingJurisdictionApply.vue?vue&type=template&id=44a42a92&scoped=true"
import script from "./settingJurisdictionApply.vue?vue&type=script&lang=js"
export * from "./settingJurisdictionApply.vue?vue&type=script&lang=js"
import style0 from "./settingJurisdictionApply.vue?vue&type=style&index=0&id=44a42a92&prod&scoped=true&lang=css"
import style1 from "./settingJurisdictionApply.vue?vue&type=style&index=1&id=44a42a92&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a42a92",
  null
  
)

export default component.exports